import type ItemMetadata from 'pages/open-course/common/models/itemMetadata';

import Evaluation from 'bundles/phoenix/models/evaluation';

type Progress = $TSFixMe; // Progress based on pages/open-course/common/models/progress

/**
 * Methods for reading the state in peer review's ItemProgress objects.
 */
class PeerState {
  declare itemMetadata: ItemMetadata;

  declare itemProgress: Progress;

  constructor(itemMetadata: ItemMetadata, itemProgress: Progress) {
    this.itemMetadata = itemMetadata;
    this.itemProgress = itemProgress;
  }

  getEvaluation() {
    return new Evaluation(this.itemProgress.getDefinition('evaluation'));
  }

  isEvaluated() {
    return this.getEvaluation().isDefined();
  }

  isFailed() {
    return this.isEvaluated() && this.getEvaluation().isFailed();
  }

  isPassed() {
    return this.isEvaluated() && this.getEvaluation().isPassed();
  }

  isReviewingComplete() {
    return this.reviewCount() >= this.requiredReviewCount();
  }

  isSubmitted() {
    return !!this.itemProgress.getDefinition('submitted');
  }

  remainingReviewCount() {
    return Math.max(this.requiredReviewCount() - this.reviewCount(), 0);
  }

  requiredReviewCount() {
    return (
      this.itemProgress.getDefinition('requiredReviewCount') ||
      this.itemMetadata.getDefinition('requiredReviewCount') ||
      0
    );
  }

  reviewCount() {
    return this.itemProgress.getDefinition('reviewCount') || 0;
  }
}

export default PeerState;
